import { initialState } from 'components/dashboard/quiz/gsapAptitude/utils/types';
import { createContext, useContext } from 'react';

//TO DO: Find less hacky solution

const gsapResponsesInitialState: initialState = {
  overallTimeLeft: { minutes: 0, seconds: 0 },
  currentQuestion: 0,
  responses: {},
  totalQuestions: 0,
  tabSwitchedCount: 0,
};
const GsapTestResponsesContextObject: {
  state: initialState;
  dispatch: Function;
} = {
  state: gsapResponsesInitialState,
  dispatch: () => {},
};

export const GsapTestResponsesContext = createContext(
  GsapTestResponsesContextObject
);

const useGsapTestResponsesContext = () => {
  return useContext(GsapTestResponsesContext);
};

export default useGsapTestResponsesContext;
